module.exports = __webpack_public_path__ + "img/81BABA_D5F3F3_BBE4E4_ABDCDC-256px.059132ef.png";